import { SWRConfig } from "swr";

import promiseHash from "@/components/promiseHash";
import ProjectDetailsCard from "@/src/components/projects/ProjectDetailsCard";
import ProjectDetailsAboutTab from "@/src/components/projects/ProjectDetailsAboutTab";
import fetchAPI from "@/components/fetchAPI";
import SEOTags from "@/components/SEOTags";
import recovery from "@/public/static/images/recovery.jpg";
import buildAbsoluteURL from "@/components/buildAbsoluteURL";

export async function getServerSideProps(context) {
  const { params } = context;

  const projectQueryKey = `/api/projects/${params.id}/`;
  const projectSupportersQueryKey = projectQueryKey + "likes/";

  const data = await promiseHash({
    project: fetchAPI(projectQueryKey, {}, context),
    projectSupporters: fetchAPI(projectSupportersQueryKey, {}, context),
  });

  const { project, projectSupporters } = data;

  if (!project.id) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      fallback: {
        [projectQueryKey]: project,
        [projectSupportersQueryKey]: projectSupporters,
      },
      ...data,
    },
  };
}

export default function ProjectDetailsPage(context) {
  const defaultProjectImage = buildAbsoluteURL(recovery.src);
  const { fallback, project, projectSupporters } = context;

  const tabRoutes = [
    {
      url: `/community-projects/${project.id}/`,
      name: "About",
      isActive: true,
    },
    { url: `/community-projects/${project.id}/blog/`, name: "Blog" },
  ];

  return (
    <SWRConfig value={{ fallback }}>
      <SEOTags
        title={project.title}
        imageLink={project.main_image_link || defaultProjectImage}
        description={project.description}
      />
      <section className="section">
        <ProjectDetailsCard
          projectId={project.id}
          tabRoutes={tabRoutes}
          projectSupporters={projectSupporters}
        >
          <ProjectDetailsAboutTab projectId={project.id} />
        </ProjectDetailsCard>
      </section>
    </SWRConfig>
  );
}
